import type { ReactElement } from 'react';
import { TellingDoors, type TalkSheetRequest } from '../talk-sheet';

const HOME_REQUEST: TalkSheetRequest = { entryType: 'home', returnTo: '/' };

/**
 * The card Ember raises when it is tapped under the tree (拍板 2026-09-14): a
 * small piece of Ember's paper above its head with one question and the same
 * two telling doors the composer and the sheet carry — behind the same gates,
 * to the same places an empty composer goes (the chat where Ember speaks
 * first; the in-browser call). `anchor` is the point above Ember's head in the
 * scene box's pixels; the card stands centred on it, kept inside the box, its
 * tail pointing down at Ember. A tap anywhere else on the scene puts it away.
 */
export function EmberTapCard({ anchor }: { anchor: { x: number; y: number } }): ReactElement {
  return (
    <div
      className="ember-tap-card"
      role="dialog"
      aria-label="Talk to Ember"
      style={{ left: `clamp(132px, ${anchor.x.toFixed(1)}px, calc(100% - 132px))`, top: `${Math.max(64, anchor.y).toFixed(1)}px` }}
      onPointerDown={(e) => e.stopPropagation()}
      onPointerUp={(e) => e.stopPropagation()}
    >
      <div className="ember-tap-paper">
        <h3 className="ember-tap-title">What would you like to talk about?</h3>
        <TellingDoors request={HOME_REQUEST} discovery="tree_ember" className="ember-tap-doors" />
      </div>
      <svg className="ember-tap-tail" viewBox="0 0 18 10" aria-hidden><path d="M0 0 L18 0 L9 10 Z" /></svg>
    </div>
  );
}
